import React from 'react'

const PL4 = (props) => {
    console.log(props)
    let tapBeers = props.tapMenu.sections[0].items
    let canBeers = props.canMenu.sections[0].items

    return (
        <div className="taps-can-page">
            <div className="background-image">
                <div className="col-left">
                    <div className="column pl4-taps-cans-pg-left">
                        {tapBeers.map(item => (
                            <div className="pl4-tap-item-page tap-item-print">
                                    {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                    <div className="print-item-line-two pl4">{item.containers[0].name} • <span className="style-print"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="col-right">
                    <div className="column pl4-taps-cans-pg-right">
                        {canBeers.map(item => (
                        <div className="pl4-can-item-page tap-item-print">
                                {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                <div className="print-item-line-two pl4 cans">{item.containers[0].name} • <span className="style-print-can pl1"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PL4